<div id="reports">
  <h1 *ngIf="(_category | async) != 'home'">{{_category | async | camelCase}} Reports </h1>
  <p-card>
    <input pInputText class="reportFilter" type="text" [formControl]="filterText" placeholder="Filter by report name" />
  </p-card>
  <p-card>
    <ul class="reportDisplay">
      <ng-template ngFor [ngForOf]="filteredReports | async" let-report>
        <li>
          <app-power-bi-report [report]="report"></app-power-bi-report>
        </li>
      </ng-template>
    </ul>
  </p-card>
</div>
